#import "./companyInfo.gql"
#import "../site/siteInfo.gql"
#import "../user/userInfo.gql"

mutation CreateCompany($id: ID!, $name: String!) {
  createCompany(id: $id, name: $name) {
    company {
      ...companyInfo
    }
  }
}

mutation DeleteCompany($id: ID!) {
  deleteCompany(id: $id) {
    name
  }
}

query GetAllCompanies {
  companies {
    ...companyInfo
  }
}

query GetAllCompaniesWithSites {
  companies {
    id
    name
    sites {
      id
      name
    }
  }
}

query GetCompany($id: ID!) {
  company(id: $id) {
    ...companyInfo
    sites {
      ...siteInfo
    }
    users {
      ...userInfo
    }
  }
}

mutation UpdateCompany($id: ID!, $name: String!) {
  updateCompany(id: $id, name: $name) {
    company {
      ...companyInfo
    }
  }
}
